import styled from 'styled-components'

export default styled.div`
  display: flex;
  align-items: flex-start;

  .item-text {
    font-size: 12px;
  }

  .button-open-drawer {
    position: relative;
    margin-bottom: 0;

    .MuiButton-root {
      border-radius: 4px;
      min-height: 3.6rem;
      padding: 0 1.6rem;
      text-transform: uppercase;
      font-size: 1.4rem;
      font-weight: 500;
      box-shadow: ${(props) => props.theme.shadows[2]};
      letter-spacing: 0.02em;
    }

    .MuiButton-contained {
      background-color: ${(props) => props.theme.palette.gray[200]};
      color: ${(props) => props.theme.palette.gray[800]};
    }

    .MuiButton-contained:hover {
      background-color: ${(props) => props.theme.palette.gray[300]};
      box-shadow: ${(props) => props.theme.shadows[4]};
    }
  }

`
